import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { CommentPosition } from 'src/app/interfaces/posts.interface';

@Component({
  selector: 'app-comments-pagination',
  templateUrl: './comments-pagination.component.html',
  styleUrls: ['./comments-pagination.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentsPaginationComponent {
  public static readonly TOP_LABEL: string = 'top';

  @Input({ required: true }) public parentCommentPosition: CommentPosition | null;

  @Output() private loadMore: EventEmitter<CommentPosition | null> = new EventEmitter<CommentPosition | null>();
  @Output() private loadAll: EventEmitter<CommentPosition | null> = new EventEmitter<CommentPosition | null>();

  public get inRepliesArea(): boolean {
    return this.parentCommentPosition !== null;
  }

  public get indexLabel(): string {
    return this.inRepliesArea ? this.parentCommentPosition.indexRoot.toString() : CommentsPaginationComponent.TOP_LABEL;
  }

  public onLoadMore(): void {
    this.loadMore.emit(this.parentCommentPosition);
  }

  public onLoadAll(): void {
    this.loadAll.emit(this.parentCommentPosition);
  }
}
